import type { ReactNode } from 'react';
import { Divider, Text } from 'ui';

type P<T> = {
  getKey: (item: T) => string;
  items: T[];
  renderItem: (item: T) => ReactNode;
  title: string;
};

const InvitationsListSection = <T,>({ getKey, items, renderItem, title }: P<T>) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <>
      <Text size="small" type="secondary">
        {title}
      </Text>
      <div className="invitations-list-section">
        {items.map((item, index) => (
          <div key={getKey(item)}>
            {renderItem(item)}
            {index < items.length - 1 ? <Divider className="invitations-list-section-divider" /> : null}
          </div>
        ))}
      </div>
    </>
  );
};

export default InvitationsListSection;
